import axios from "axios";
import APIURL from "../../../Main/apiurl";

const getAuthConfig = () => {
  const token = localStorage.getItem("user");
  if (!token) {
    localStorage.clear();
    window.location.href = "/";
    throw new Error("Authentication required");
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };
};

const upload_Attachments = async (data) => {
  try {
    const config = getAuthConfig();
    const response = await axios.post(
      `${APIURL}/upload`,
      data,
      config
    );

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Document Uploaded failed");
    }

    return response.data;
  } catch (error) {
    console.error("Error uploading document:", error.message);
    throw error;
  }
};

const get_attachments = async (file) => {
  try {
    const config = getAuthConfig();
    const response = await axios.get(
      `${APIURL}/${file}`,
      config
    );

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Failed to fetch file");
    }

    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching file:", error.message);
    throw error;
  }
};

const delete_attachment = async (file) => {
  try {
    const config = getAuthConfig();
    const response = await axios.delete(
      `${APIURL}/${file}`,
      config
    );

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Failed to delete file");
    }

    return response.data.data || [];
  } catch (error) {
    console.error("Error deleting file:", error.message);
    throw error;
  }
};


export { upload_Attachments, get_attachments, delete_attachment };
